import { objectToQueryString } from './objectToQueryString';

const toUrl = (query) => {
  const { protocol, host, pathname } = window.location;

  let url = `${protocol}//${host}${pathname}`;
  if (query) {
    url += `?${query}`;
  }

  return url;
};

export function updateLocationQuery(data = {}) {
  if (!window.history.pushState) {
    return;
  }

  const query = objectToQueryString(data);
  const url = toUrl(query);

  window.history.pushState({ path: url }, '', url);
}
